    
import { Injectable, ɵConsole } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { AppConfigService } from '../app-config.service';
import { PublicUtils } from '../../utils/PublicUtils';
@Injectable({
  providedIn: 'root'
})
export class CmsService {
  publicUtils = new PublicUtils();
  header:HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json, text/javascript, */*; q=0.01'
  })
  constructor(private http: HttpClient, private appConfig: AppConfigService){}
  getContents(){
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].cms}`, 
    this.getEncodedString({service: 1, forms: JSON.stringify([
      {name:"assets", value:this.appConfig.landing["_value"]["formulario_contenido"]},
      {name:"programas", value:`${this.appConfig.config["programs"]}`},
      {name:"programsSENA", value: "824" }
    ])}),
    {headers:this.header});
  }
  getContentsDL(){
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].cms}`, 
    this.getEncodedString({service: 1, forms: JSON.stringify([
      {name:"assets", value:this.appConfig.landing["_value"]["formulario_contenido"]},
      {name:"programas", value:`${this.appConfig.config["programs"]}`},
    ])}),
    {headers:this.header});
  }

  private getEncodedString(params:any){
    let str = '';
    for (let name in params) {
        str += name + '=' + encodeURIComponent(params[name]) + '&'
    }
    let pos = str.length;
    str = str.substring(0, pos - 1) + str.substring(pos, str.length);
    return str;
  }
}